import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.sizes.fullPageNoAppBar,
    ...theme.palette.primaryBackground,
    display: 'flex',
    flexDirection: 'row',
  },
  landingPageContainer: {
    margin: 0,
    paddingLeft: '50px',
    paddingRight: '50px',
    paddingBottom: '15px',
    [theme.breakpoints.down('md')]: {
      paddingBottom: '40px',
      paddingLeft: '35px',
      paddingRight: '35px',
    },
  },
  header: {
    padding: '30px 30px 20px 30px',
    fontWeight: 'bold',
    [theme.breakpoints.down('lg')]: {
      fontSize: '26px',
    },
  },
  icon: {
    width: 50,
    height: 50,
    transition: 'color 0.3s ease',
  },
  activeIcon: {
    color: theme.palette.primary.main,
  },
  item: {
    padding: '10px',
    borderRadius: '10px',
    cursor: 'pointer',
    transition: 'transform 0.2s, box-shadow 0.2s, background-color 0.3s',
    '&:hover': {
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.divider}`,
      transform: 'scale(1.02)',
      boxShadow: theme.shadows[4],
    },
    '&.active': {
      transform: 'scale(1.05)',
      boxShadow: theme.shadows[6],
      backgroundColor: theme.palette.action.selected,
    },
  },
  expandedItem: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[6],
    transform: 'scale(1.05)',
    zIndex: 1,
    '&:hover': {
      transform: 'scale(1.05)', // Prevent further scaling when already expanded
    },
  },
  scroll: {
    width: '100%',
    height: '100%',
    overflowY: 'auto',
  },
  submenuHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  expandButton: {
    padding: 4,
    transition: 'background-color 0.3s ease',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  submenuContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
  },
  submenuButton: {
    justifyContent: 'flex-start',
    textAlign: 'left',
    marginBottom: theme.spacing(1),
    transition: 'all 0.2s ease',
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      transform: 'translateX(5px)',
    },
  },
}));
